// extracted by mini-css-extract-plugin
export default {"params":"Params_params__jtbQ7","Dashboard_Fixed":"Params_Dashboard_Fixed__m2fpd","ant-space-item":"Params_ant-space-item__SsSO1"};